export default "__VITE_ASSET__9843d540__"